import React, { useState } from "react";
import EmployeeSummary from "./EmployeeSummary";
import WebsiteProfile from "./WebsiteProfile";
import ContractorLocation from "./ContractorLocation";
import { Icon } from "@iconify-icon/react";
import { useUser } from "../../Context/UserContext";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

type ViewProfileProps = {
  user?: any; // Optional - will use from context if not provided
  userProfile?: any;
  staff?: any;
  pbsRegionsServiced?: any;
};

const ViewProfile = (props: ViewProfileProps) => {
  const { user: contextUser } = useUser();
  const user = props.user || contextUser; // Use prop or context

  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { id: 0, label: "Employee Summary" },
    { id: 1, label: "Website Profile" },
    { id: 2, label: "Employee Location" },
  ];

  const tabContent = [
    <div key={0} className="content">
      <Card className="contentCard">
        <CardHeader className="contentHeader">
          <CardTitle className="contentTitle">
            <Icon className="cardIcon" icon="clarity:employee-solid" />
            Employee Information
          </CardTitle>
        </CardHeader>
        <CardContent>
          <EmployeeSummary
            user={user}
            staff={props.staff}
            pbsRegionsServiced={props.pbsRegionsServiced}
          />
        </CardContent>
      </Card>
    </div>,
    <div key={1} className="content">
      <Card className="contentCard">
        <CardHeader className="contentHeader">
          <CardTitle className="contentTitle">
            <Icon className="cardIcon" icon="gg:profile" />
            Website Profile
          </CardTitle>
        </CardHeader>
        <CardContent>
          <WebsiteProfile userProfile={props.userProfile} />
        </CardContent>
      </Card>
    </div>,
    <div key={2} className="content">
      <Card className="contentCard">
        <CardHeader className="contentHeader">
          <CardTitle className="contentTitle">
            <Icon className="cardIcon" icon="mdi:location" />
            Employee Location
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ContractorLocation user={props.user} />
        </CardContent>
      </Card>
    </div>,
  ];

  return (
    <div>
      <h1 className="title">Employee Profile</h1>

      <div className="tabContainer">
        <nav className="tabNav">
          {tabs.map((tab) => (
            <Button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              variant={activeTab === tab.id ? "default" : "ghost"}
              className={`tabButton ${
                activeTab === tab.id ? "activeTab" : "inactiveTab"
              }`}
            >
              {tab.label}
            </Button>
          ))}
        </nav>
      </div>

      <div className="contentContainer">{tabContent[activeTab]}</div>
    </div>
  );
};

export default ViewProfile;
